module.exports = __webpack_public_path__ + "static/media/iso-9001.a474342a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/iso-9001.jpg
// module id = 1111
// module chunks = 0